export const PRODUCT_QUANTITY_STORAGE_DECIMAL_PLACES = 4;
export const DEFAULT_QUANTITY_MAX_DECIMAL_PLACES = 0;
export const QUANTITY_MAX_DECIMAL_PLACE_VALUES = [0, 1, 2, 3, 4];
const STORAGE_SCALE = 10 ** PRODUCT_QUANTITY_STORAGE_DECIMAL_PLACES;
/** Keep quantity arithmetic at the precision used by inventory storage. */
export function roundProductQuantity(value) {
    return Math.round(value * STORAGE_SCALE) / STORAGE_SCALE;
}
export const PRODUCT_QUANTITY_PRECISION_ERROR_MESSAGE = "Usá una cantidad entera para este combo; sus componentes no admiten esa fracción.";
export class ProductQuantityPrecisionError extends Error {
    constructor() {
        super(PRODUCT_QUANTITY_PRECISION_ERROR_MESSAGE);
        this.name = "ProductQuantityPrecisionError";
    }
}
/** Component stock must be represented exactly, before movement persistence. */
export function multiplyProductQuantity(quantity, componentQuantity) {
    const expandedQuantity = quantity * componentQuantity;
    if (!isQuantityAtAllowedPrecision({
        value: expandedQuantity,
        maxDecimalPlaces: PRODUCT_QUANTITY_STORAGE_DECIMAL_PLACES,
    })) {
        throw new ProductQuantityPrecisionError();
    }
    return roundProductQuantity(expandedQuantity);
}
const DEFAULT_QUANTITY_SETTINGS = {
    version: 1,
    maxDecimalPlaces: DEFAULT_QUANTITY_MAX_DECIMAL_PLACES,
};
function isRecord(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
export function isQuantityMaxDecimalPlaces(value) {
    return QUANTITY_MAX_DECIMAL_PLACE_VALUES.some((supportedValue) => supportedValue === value);
}
export function quantityStepForDecimalPlaces(maxDecimalPlaces) {
    return (10 ** -maxDecimalPlaces);
}
export function resolveOrganizationQuantityPolicy(settings) {
    const quantities = isRecord(settings) ? settings.quantities : undefined;
    const resolvedSettings = isRecord(quantities) &&
        quantities.version === 1 &&
        isQuantityMaxDecimalPlaces(quantities.maxDecimalPlaces)
        ? {
            version: 1,
            maxDecimalPlaces: quantities.maxDecimalPlaces,
        }
        : DEFAULT_QUANTITY_SETTINGS;
    return {
        ...resolvedSettings,
        inputStep: quantityStepForDecimalPlaces(resolvedSettings.maxDecimalPlaces),
    };
}
function toStorageUnits(value) {
    if (!Number.isFinite(value)) {
        return null;
    }
    const scaledValue = value * STORAGE_SCALE;
    const storageUnits = Math.round(scaledValue);
    const floatingPointTolerance = Number.EPSILON * Math.max(1, Math.abs(scaledValue)) * 8;
    if (!Number.isSafeInteger(storageUnits) ||
        Math.abs(scaledValue - storageUnits) > floatingPointTolerance) {
        return null;
    }
    return storageUnits;
}
export function isQuantityAtAllowedPrecision(input) {
    const storageUnits = toStorageUnits(input.value);
    if (storageUnits === null) {
        return false;
    }
    if (input.originalValue !== undefined) {
        const originalStorageUnits = toStorageUnits(input.originalValue);
        if (originalStorageUnits !== null &&
            originalStorageUnits === storageUnits) {
            return true;
        }
    }
    const requiredMultiple = 10 ** (PRODUCT_QUANTITY_STORAGE_DECIMAL_PLACES - input.maxDecimalPlaces);
    return storageUnits % requiredMultiple === 0;
}
export function quantityPrecisionErrorMessage(maxDecimalPlaces) {
    return maxDecimalPlaces === 0
        ? "Usá cantidades enteras."
        : `Usá hasta ${maxDecimalPlaces} decimales.`;
}
